import React, { ReactElement, useState, useEffect } from 'react';
import * as _ from 'lodash';
import Collapse from 'components/common/CollapseBasic';
import { IconButton, Dialog, FlatButton, TextField } from 'material-ui';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import ArrowToRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addNotification } from 'actions/notifications/notifications';

export function withButtonedCollapse(Component, other) {
    return props => (
        <Collapse
            controls={Component && <Component />}
            {...props}
        />
    );
}

/**
 * @param {{ type: string, 
 *           size: any, 
 *           sizes?: any, 
 *           field?: string, 
 *           index: number, 
 *           accept: (any) => void, 
 *           reject: (any) => void, 
 *           transfer: (any) => void, 
 *           emailIds: string[],
 *           keep_id?: boolean,
 *           addNotification: function,
 *           addToMultiTransfer: function,
 *           shouldShowApproveReject: boolean,
 * }} props,
 * @returns {ReactElement}
 */
function ControlButtons({
    type, size, sizes, field, index, accept, reject, transfer, emailIds, keep_id, addNotification,
    addToMultiTransfer, shouldShowApproveReject,
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [reason, setReason] = useState('');

    useEffect(() => {
        addToMultiTransfer({ 
            type, index, size, sizes, field, emailIds, keep_id,
        });
    }, []);

    const submitReject = () => {
        if (!reason) {
            addNotification({
                title: 'Error',
                message: 'Reject reason is required',
                level: 'error',
                _id: new Date().getMilliseconds(),
                autoDismiss: 3,
            });
            return;
        }
        reject({
            type, index, size, sizes, field, emailIds, reason,
        });
        setReason('');
        setIsOpen(false);
    };

    const actions = [
        <FlatButton
            label="Cancel"
            primary
            onClick={() => setIsOpen(false)}
        />,
        <FlatButton
            label="Save"
            primary
            keyboardFocused
            onClick={() => submitReject()}
        />,
    ];

    return (
        <div>
            <Dialog
                open={isOpen}
                actions={actions}
            >
                <TextField 
                    value={reason}
                    floatingLabelText='Reject reason'
                    onChange={e => setReason(e.target.value)}
                    multiLine
                    fullWidth
                    errorText={!reason && 'Reject reason is required'}
                />
            </Dialog>
            {
                shouldShowApproveReject &&
                <React.Fragment>
                    <IconButton
                        style={{ width: '24px', height: '30px', padding: 0 }}
                    >
                        <ContentRemoveIcon
                            onClick={(e) => {
                                setIsOpen(true);
                                e.stopPropagation();
                            }}
                            color='red'
                        />
                    </IconButton>
                    <IconButton
                        style={{ width: '24px', height: '30px', padding: 0 }}
                    >
                        <ContentAddIcon
                            onClick={(e) => {
                                accept({ 
                                    type, index, size, sizes, field, emailIds, keep_id,
                                });
                                e.stopPropagation();
                            }}
                            color='green'
                        />
                    </IconButton>
                </React.Fragment>
            }
            <IconButton
                style={{ width: '24px', height: '30px', padding: 0 }}
            >
                <ArrowToRight
                    onClick={(e) => {
                        transfer({
                            type, index, size, sizes, field, emailIds, keep_id,
                        });
                        e.stopPropagation();
                    }}
                />
            </IconButton>
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(ControlButtons);

export const CollapseBody = withButtonedCollapse();

export const transfer = (modification, setModifySizes) => {
    const {
        size, sizes, field: groupField, type, emailIds, keep_id,
    } = modification;
    const field = sizesFieldsNamesMap[type];
    let value;

    if (['string', 'boolean'].includes(typeof size[field].value)) {
        value = size[field].value;
    } else if (keep_id) {
        value = size[field].value;
    } else {
        value = _.omit(size[field].value, ['_id']);
    }

    setModifySizes({ field, value });

    return { 
        field, emailIds, groupField, sizes, type,
    };
};

export function generateHatchTweenDeckStr(data) {
    const { l, b, h } = data;
    let str = '';

    if (l) str += `L: ${l} `;
    if (b) str += `B: ${b} `;
    if (h) str += `H: ${h} `;

    return str;
}

export const sizesMap = {
    grouppedByGears: 'Gears',
    grouppedBySpeedConsumption: 'Speeds and consumption',
    grouppedByBoxShaped: 'Box shaped',
    grouppedByOpenHatch: 'Open hatch',
    grouppedByTypeByConstruction: 'Type by construction', 
    grouppedByTypeByPurpose: 'Type by purpose',
    grouppedByTypeBySpecialty: 'Type by specialty', 
    grouppedByTechEquipCertificate: 'TechEquipCertificate',
    grouppedByDeadWeight: 'Deadweight', 
    grouppedByRt: 'Tonnage',
    grouppedByHatches: 'Hatches',
    grouppedByHolds: 'Holds',
    grouppedByCapacityV2: 'Capacity',
    grouppedByCells: 'Cells',
    grouppedByFlags: 'Flag',
    grouppedByRegisterClass: 'Register class',
    grouppedByPIClub: 'PI Club',
    grouppedByGrabs: 'Grabs',
    grouppedByDimensions: 'Dimensions',
};

export const sizesFieldsNamesMap = {
    grouppedByGears: 'gearV2',
    grouppedBySpeedConsumption: 'speedConsumptionV2',
    grouppedByBoxShaped: 'boxShaped',
    grouppedByOpenHatch: 'openHatch',
    grouppedByTypeByConstruction: 'typeByConstruction', 
    grouppedByTypeByPurpose: 'typeByPurpose',
    grouppedByTypeBySpecialty: 'typeBySpecialty', 
    grouppedByTechEquipCertificate: 'techEquipCertificate',
    grouppedByDeadWeight: 'deadWeight', 
    grouppedByRt: 'rt',
    grouppedByCells: 'cells',
    grouppedByCapacityV2: 'capacityV2',
    grouppedByFlags: 'flag', 
    grouppedByRegisterClass: 'registerClass',
    grouppedByPIClub: 'piClub',
    grouppedByGrabs: 'grabV2',
    grouppedByDimensions: 'dimensions',
};

export const deadWeightFieldsNamesMap = {
    sLoaded: 'Summer loaded',
    sDWT: 'Summer dwt',
    sDWCC: 'Summer dwcc', 
    sDraft: 'Summer draft',
    sTpc: 'Summer tpc',
    sTpi: 'Summer tpi',
    
    tLoaded: 'Tropical loaded',
    tDWT: 'Tropical dwt',
    tDWCC: 'Tropical dwcc', 
    tDraft: 'Tropical draft',
    tTpc: 'Tropical tpc',
    tTpi: 'Tropical tpi',

    wLoaded: 'Winter loaded',
    wDWT: 'Winter dwt',
    wDWCC: 'Winter dwcc', 
    wDraft: 'Winter draft',
    wTpc: 'Winter tpc',
    wTpi: 'Winter tpi',

    fLoaded: 'Fresh loaded',
    fDWT: 'Fresh dwt',
    fDWCC: 'Fresh dwcc', 
    fDraft: 'Fresh draft',
    fTpc: 'Fresh tpc',
    fTpi: 'Fresh tpi',
};

export const rtFieldsNamesMap = {
    gt: 'GT', nt: 'NT', suezGt: 'Suez GT', suezNt: 'Suez NT', panamaGt: 'Panama GT', panamaNt: 'Panama NT',
};

export const capacityV2FieldsNamesMap = {
    bale: 'Bale', grain: 'Grain', teu: 'TEU', feu: 'FEU', summary: 'Summary',
};

export const techEquipCertificateFieldsNamesMap = {
    a60BulkheadFitted: 'A60Bulkhead',
    aussieFitted: 'Aussie',
    cementHolesFitted: 'Cement holes', 
    co2Fitted: 'CO2',
    iceClass: 'Ice class',
    imoApp: 'Imo app',
    imoClass: 'Imo class', 
    imoFitted: 'Imo',
    itfFitted: 'Itf',
    lakesFitted: 'Lakes',
    logsFitted: 'Logs', 
    referPlugFitted: 'Refer plug',
    referPlugsAmount: 'R. plugs amount',
    scrubber_fitted: 'Scrubber',
    strengthenHeavy: 'Strengthen heavy',
    ventilationFitted: 'Vent. fit',
    ventilation: 'Ventilation', 
};

export const cellsNamesMap = {
    holds: 'Holds', hatches: 'Hatches', tweenDecks: 'Tweendecks',
};

export const basicNamesFieldsMap = {
    name: 'Name',
};

export const registerClassFieldsMap = {
    ...basicNamesFieldsMap,
    iacsRegister: 'IACS',
    isPublic: 'Public',
};

export const dimensionsFieldsMap = {
    loa: 'Loa', beam: 'Beam', lbp: 'Lbp', depth: 'Depth', depthMoulded: 'Depth-moulded',
};



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/utils.js